import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent implements OnInit {
  @Input() deleteDialog: boolean = false;
  @Input() confirmationText: string = "Are you sure you want to delete record?";
  @Output() shouldDelete: EventEmitter<boolean> = new EventEmitter<boolean>(); 

  constructor() { }

  ngOnInit(): void {
  }

  deleteResponse(response: boolean) {
    this.deleteDialog = false;
    this.shouldDelete.emit(response);
  }
}
